import type { GetEventsForPerformanceEntries } from '../types';

import { getLongAnimationFramePerformanceEvent } from './getLongAnimationFramePerformanceEvent';
import type { PerformanceLongAnimationFrameTiming } from './types';

const reportingThresholdInMilliseconds = 150;

export const getEventsForLongAnimationFrameEntries: GetEventsForPerformanceEntries = (entries) =>
  entries
    .filter((entry) => entry.duration > reportingThresholdInMilliseconds)
    .map((entry) => getLongAnimationFramePerformanceEvent(entry as PerformanceLongAnimationFrameTiming));
